export default "__VITE_ASSET__C6bZM$A8__"